import { render, staticRenderFns } from "./Box11.vue?vue&type=template&id=f77684b6&scoped=true&"
import script from "./Box11.vue?vue&type=script&lang=js&"
export * from "./Box11.vue?vue&type=script&lang=js&"
import style0 from "./Box11.vue?vue&type=style&index=0&id=f77684b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77684b6",
  null
  
)

export default component.exports